/**
 * 유해위험기계기구(작업별) 기본정보(HAZ_BASIC_02) 컬럼 정의
 * HAZ_BASIC_02 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

/**
 * 유해위험기계기구(작업별) 기본정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
    }),
    // 채번 컬럼 (숨김)
    CreateColumn('chaebun', '채번', 'left', 110, false, false, true, 'text', {
      minWidth: 110,
    }),
    // 구분 컬럼 (필수)
    CreateColumn('gubun', '구분', 'left', 100, true, true, false, 'text', {
      flex: 1,
    }),
    // 기계·기구명 컬럼 (필수)
    CreateColumn(
      'machineName',
      '기계·기구명',
      'left',
      150,
      true,
      true,
      false,
      'text',
      {
        flex: 1,
      }
    ),
    // 형식 컬럼
    CreateColumn('serialNo', '형식', 'left', 100, true, false, false, 'text', {
      flex: 1,
    }),
    // 인증번호 컬럼
    CreateColumn('passNo', '인증번호', 'left', 120, true, false, false, 'text', {
      flex: 1,
    }),
    // 용량 컬럼
    CreateColumn('capacity', '용량', 'left', 100, true, false, false, 'text', {
      flex: 1,
    }),
    // 설치장소 컬럼
    CreateColumn(
      'installLocation',
      '설치장소',
      'left',
      120,
      true,
      false,
      false,
      'text',
      {
        flex: 1,
      }
    ),
    // 인증일자 컬럼 (date)
    CreateColumn(
      'inspectionDate',
      '인증일자',
      'center',
      140,
      true,
      false,
      false,
      'date',
      {
        minWidth: 140,
      }
    ),
    // 비고 컬럼
    CreateColumn('remark', '비고', 'left', 150, true, false, false, 'text', {
      flex: 1,
    }),
    // 인증서 컬럼 (fileButton)
    CreateColumn(
      'certificateFileName',
      '인증서',
      'center',
      200,
      false,
      false,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data, fieldName) => {
          props.PopupClickEvent1?.(data);
        },
        fileButtonFileNameKey: 'certificateFileName',
        fileButtonFilePathKey: 'certificateFilePath',
        width: 200,
      }
    ),
    // 인증서 파일명 컬럼 (숨김)
    CreateColumn(
      'certificateFileName',
      '인증서 파일명',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
    // 인증서 저장명 컬럼 (숨김)
    CreateColumn(
      'certificateSaveName',
      '인증서 저장된 파일명',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
    // 인증서 파일 경로 컬럼 (숨김)
    CreateColumn(
      'certificateFilePath',
      '인증서 파일 주소',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
    // 미리보기 파일 경로 컬럼 (숨김)
    CreateColumn(
      'previewFilePath',
      '미리보기 파일 경로',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
